var search_icon = document.querySelectorAll('.search-button'),
    search_box = document.querySelector('.search-box');

search_icon.forEach(function(el) {
    el.addEventListener('click', function() {
        search_box.classList.toggle('search-box--reveal')
        document.getElementById('searchTerm').focus();
    })
})